module.exports = __webpack_public_path__ + "static/media/Group.ac4c564a.svg";